/**
 *  @class
 *  @function ScrollingBoxes
 */
if (!customElements.get('scrolling-boxes')) {
  class ScrollingBoxes extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.inner = this.querySelector('.scrolling-boxes--inner');
      this.sectionIndex = this.dataset.sectionIndex;
      if (Shopify.designMode) {
        let children = [...this.closest('.shopify-section').parentNode.children];
        this.sectionIndex = children.indexOf(this.closest('.shopify-section')) + 1;
      }
      this.galleryVideoList = Array.from(this.querySelectorAll('.scrolling-boxes--box .scrolling-boxes--video'));

      this.hoverPlayList = this.galleryVideoList.filter((item) => {
        return item.classList.contains('hover-play') && item;
      });

      this.autoPlayList = this.galleryVideoList.filter((item) => {
        return !item.classList.contains('hover-play') && item;
      });

      this.autoPlayList.forEach((item, i) => {
        item.querySelector('video').play();
      });

      this.setHoverPlayList();

      this.setupScroll();
    }

    setupScroll() {
      const _this = this,
        start = this.sectionIndex == 1 ? "top top" : "center center",
        dir = document.dir === 'rtl' ? 1 : -1;

      gsap.to(this.inner, {
        x: () =>
          dir * (this.inner.scrollWidth - document.documentElement.clientWidth) + "px",
        ease: "none",
        scrollTrigger: {
          trigger: this.inner,
          start: start,
          invalidateOnRefresh: true,
          pin: true,
          scrub: 1
        }
      });
    }

    setHoverPlayList() {
      this.hoverPlayList.forEach((item, i) => {
        item.querySelector('video').currentTime = 0.1;
        item.parentElement.addEventListener('mouseenter', () => this.playVideo(item));
        item.parentElement.addEventListener('mouseleave', () => this.pauseVideo(item));
      });
    }

    playVideo(videoContainer) {
      videoContainer.querySelector('video').play();
    }
    pauseVideo(videoContainer) {
      videoContainer.querySelector('video').pause();
    }
  }
  customElements.define('scrolling-boxes', ScrollingBoxes);
}